<template>
  <!-- 表格 -->
  <div class="monthly_historical_sincerity_gold">
    <div class="report_title">
      <label class="report-line" />
      <span class="report-title">月历史诚意金</span>
      <exportConfig
        :all-head="allHead"
        :header-name="headerName"
        :width="'230'"
      />
    </div>
    <el-table
      :data="tableData"
      class="monthlyHistoricalSincerityGold"
    >
      <el-table-column
        fixed
        label="序号"
        align="center"
        width="70px"
      >
        <template slot-scope="scope">
          {{ scope.$index+1 }}
        </template>
      </el-table-column>
      <af-table-column
        fixed
        prop="transDate"
        label="日期"
        width="100"
      />
      <af-table-column
        fixed
        prop="beginBalance"
        label="上日诚意金余额"
      />
      <af-table-column
        fixed
        prop="fundInSum"
        label="总计转入"
        width="100"
      />
      <af-table-column
        prop="fundOutSum"
        label="总计转出"
        width="100"
      />
      <af-table-column
        prop="feeBalance"
        label="软件使用费"
        width="100"
      />
      <af-table-column
        prop="lxCloseProfit"
        label="预计当日补偿金"
      />
      <af-table-column
        prop="dayBalance"
        label="本日诚意金余额"
      />
      <af-table-column
        prop="lxExDepositBanlance"
        label="基本担保履约资金(订货)"
      />
      <af-table-column
        prop="lxDeDepositBalanceAdv"
        label="基本担保履约资金(提前)"
      />
      <af-table-column
        prop="lxDeDepositBanlance"
        label="基本担保履约资金(到期)"
      />
      <af-table-column
        prop="lxOpenProfit"
        label="补充担保履约资金(订货)"
      />
      <af-table-column
        prop="deliveryProfitAdvance"
        label="补充担保履约资金(提前)"
      />
      <af-table-column
        prop="deliveryProfitDelistFreeze"
        label="补充担保履约资金冻结(到期)"
      />
      <af-table-column
        prop="canUseBalance"
        label="可用资金"
      />
    </el-table>
    <MoreData
      :all-data="allData"
      :table-data.sync="tableData"
    />
  </div>
</template>
<script>
import api from '@/api'
import dayJs from 'dayjs'
import MoreData from '@/components/more-data'
import exportConfig from '@/components/exportConfig'

export default {
  name: 'MonthlyHistoricalSincerityGold',
  components: {
    MoreData,
    exportConfig,
  },
  props: {
    query: {
      type: Object,
      default: () => {}
    }
  },
  data () {
    return {
      allHead: [{
        fieldLabel: '日期',
        excelColumn: 'transDate'
      },
      {
        fieldLabel: '上日诚意金余额',
        excelColumn: 'beginBalance'
      },
      {
        fieldLabel: '总计转入',
        excelColumn: 'fundInSum'
      },
      {
        fieldLabel: '总计转出',
        excelColumn: 'fundOutSum'
      },
      {
        fieldLabel: '软件使用费',
        excelColumn: 'feeBalance'
      },
      {
        fieldLabel: '预计当日补偿金',
        excelColumn: 'lxCloseProfit'
      },
      {
        fieldLabel: '本日诚意金余额',
        excelColumn: 'dayBalance'
      },
      {
        fieldLabel: '基本担保履约资金(订货)',
        excelColumn: 'lxExDepositBanlance'
      },
      {
        fieldLabel: '基本担保履约资金(提前)',
        excelColumn: 'lxDeDepositBalanceAdv'
      },
      {
        fieldLabel: '基本担保履约资金(到期)',
        excelColumn: 'lxDeDepositBanlance'
      },
      {
        fieldLabel: '补充担保履约资金(订货)',
        excelColumn: 'lxOpenProfit'
      },
      {
        fieldLabel: '补充担保履约资金(提前)',
        excelColumn: 'deliveryProfitAdvance'
      },
      {
        fieldLabel: '补充担保履约资金冻结(到期)',
        excelColumn: 'deliveryProfitDelistFreeze'
      },
      {
        fieldLabel: '可用资金',
        excelColumn: 'canUseBalance'
      },
      ],
      currentPage: 1,
      total: 0,
      pageSize: 10,
      tableData: [], // 表格数据
      allData: [], // 用来储存全部的表格数据
      headerName: '月报表_月历史诚意金',
    }
  },
  methods: {
    // 分页查询
    async fetchList (currentNo, pageSize) {
      if (pageSize) {
        this.pageSize = pageSize
      }
      this.currentNo = currentNo || this.currentNo || 1
      let param = {
        ...this.query,
        currentPage: this.currentPage,
        pageSize: this.pageSize
      }
      param.monthDate = dayJs(this.query.date).format('YYYYMM')
      let res = await api.spotPurchaseSaleInquiry.MonthlyHistoricalSincerityGold(param)
      this.allData = res.data || [] // 储存全部表格数据
    },
  }
}

</script>

<style lang="scss" scoped>
  .monthly_historical_sincerity_gold ::v-deep .el-table__fixed .el-table__fixed-body-wrapper tbody>tr:last-child td:nth-child(3) div {
    display: none;
  }

  .monthly_historical_sincerity_gold ::v-deep .el-table .el-table__body-wrapper tbody>tr:last-child {

    td:nth-child(8) div,
    td:nth-child(9) div,
    td:nth-child(10) div,
    td:nth-child(11) div,
    td:nth-child(12) div,
    td:nth-child(13) div,
    td:nth-child(14) div,
    td:nth-child(15) div {
      display: none;
    }
  }

</style>
